import { getMinValue, getMaxValue, } from '@getaccept/editor-lib-new/src/helpers/pricing-table/pricing-table-units-modifier-menu.helper';
import { allowedNumericKeys, PricingTableHelper, UnitInputType } from '@getaccept/editor-lib-new';
import DropdownItemsWrapper from '@getaccept/editor-lib-new/src/components/DropdownItemsWrapper.vue';
import { computed, onBeforeUnmount, onMounted, watch, defineComponent, ref } from 'vue';
export default defineComponent({
    name: 'PricingTableUnitsModifierMenu',
    components: {
        DropdownItemsWrapper,
    },
    props: {
        inputField: {
            type: Object,
            default: () => ({}),
        },
        open: { type: Boolean },
        disabled: { type: Boolean },
    },
    emits: ['close', 'update-field'],
    setup(props, { emit }) {
        const defaultValueError = ref('');
        const currentValue = ref(null);
        watch(() => props.open, (open) => {
            if (!open) {
                return;
            }
            defaultValueError.value = '';
        });
        const close = () => {
            emit('close');
        };
        const handleEsc = () => {
            close();
        };
        const handleEnter = () => {
            handleDefaultValueBlur();
            if (defaultValueError.value === '') {
                close();
            }
        };
        const handleDefaultValueBlur = () => {
            const hasValueChanged = Number(props.inputField.value) !== currentValue.value;
            const isValidValue = hasValueChanged && !!currentValue.value;
            if (!isValidValue || defaultValueError.value) {
                return;
            }
            emit('update-field', { id: props.inputField.id, value: String(currentValue.value) });
        };
        const handleKeyPress = (event) => {
            if (!allowedNumericKeys.includes(event.key)) {
                return;
            }
            const { value } = event.target;
            handleDefaultValueChange(Number(value));
        };
        const minValue = computed(() => {
            const value = getMinValue(props.inputField);
            return Number(value) || null;
        });
        const maxValue = computed(() => {
            const value = getMaxValue(props.inputField);
            return Number(value) || null;
        });
        const isOneStep = (value) => value === currentValue.value + 1 || value === currentValue.value - 1;
        const isWithinRange = (value) => {
            const isWithinMinRange = minValue.value === null || value >= minValue.value;
            const isWithinMaxRange = maxValue.value === null || value <= maxValue.value;
            return isWithinMinRange && isWithinMaxRange;
        };
        const handleStep = (value) => {
            if (!isOneStep(value) || !isWithinRange(value)) {
                return;
            }
            handleDefaultValueChange(value);
        };
        const handleDefaultValueChange = (value) => {
            currentValue.value = value;
            if (minValue.value === null || maxValue.value === null) {
                defaultValueError.value = '';
            }
            else if (minValue.value > 0 && value < minValue.value) {
                defaultValueError.value = 'default-value-error-cant-be-lower-than-min-value';
            }
            else if (maxValue.value > 0 && value > maxValue.value) {
                defaultValueError.value = 'default-value-error-cant-be-higher-than-max-value';
            }
            else {
                defaultValueError.value = '';
            }
        };
        onMounted(() => {
            currentValue.value = Number(props.inputField.value);
        });
        onBeforeUnmount(() => {
            handleDefaultValueBlur();
        });
        return {
            currentValue,
            defaultValueError,
            close,
            handleEsc,
            handleEnter,
            handleDefaultValueBlur,
            isOneStep,
            isWithinRange,
            handleDefaultValueChange,
            handleStep,
            handleKeyPress,
            isKeyAllowed: PricingTableHelper.isKeyAllowed,
            UnitInputType,
            getMinValue,
            getMaxValue,
        };
    },
});
